export const HeaderScroll = () => {
  
  let lastScrollTop = 0
  const triggerHeight = 220
  let offset = 0

  
  const header = document.querySelector('#header')
  const banner = document.querySelector('.banner') ?? null
  evaluateHeaderClass()
  window.addEventListener('scroll', () => {
    evaluateHeaderClass()
  }, {passive: true})

  function evaluateHeaderClass(){
    //add banner as offset
    if (banner && banner.offsetHeight) {
       offset = banner.offsetHeight
    }

    const st = window.pageYOffset || document.documentElement.scrollTop
    header.classList.toggle('header--scroll', st > (triggerHeight + offset) && st > lastScrollTop)
    header.classList.toggle('header--detached', st > 1)
    lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
  }
}
